import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  const etapas = [{
    emoji: '🟢',
    text: 'Postparto inmediato'
  }, {
    emoji: '🟡',
    text: 'Postparto tardío'
  }, {
    emoji: '🔴',
    text: 'Crisis y DPP'
  }, {
    emoji: '💼',
    text: 'Gestión de práctica'
  }, {
    emoji: '📱',
    text: 'Comunicación profesional'
  }, {
    emoji: '💻',
    text: 'Práctica independiente'
  }];
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy text-white relative overflow-hidden" data-id="element-246">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-247">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-gold/10 blur-[100px]" data-id="element-248"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-terracotta/10 blur-[100px]" data-id="element-249"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-251">
          <p className="text-gold font-medium tracking-wide uppercase mb-3 md:mb-4 text-xs md:text-sm" data-id="element-252">
            Sistema N°1 para Profesionales de Postparto en Argentina
          </p>

          <h2 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6 text-balance leading-tight" data-id="element-253">
            KIT PROFESIONAL POSTPARTO™ <br data-id="element-254" />
            <span className="text-gold" data-id="element-255">MEGAPACK — SISTEMA COMPLETO</span>
          </h2>

          <p className="text-xl md:text-3xl font-serif italic text-white/90 mb-8 md:mb-12" data-id="element-256">
            6 Tomos + 6 Bonos <br className="md:hidden" data-id="element-257" />
            <span className="hidden md:inline" data-id="element-258"> | </span>
            Todas las etapas — Todo resuelto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-16" data-id="element-259">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02
        }} className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-8 backdrop-blur-sm" data-id="element-260">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-1 md:mb-2" data-id="element-261">
              +600
            </div>
            <div className="text-white/80 font-medium text-sm md:text-base" data-id="element-262">
              páginas de contenido estructurado
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.02
        }} className="bg-white/5 border border-white/10 rounded-2xl p-5 md:p-8 backdrop-blur-sm" data-id="element-263">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-1 md:mb-2" data-id="element-264">
              80+
            </div>
            <div className="text-white/80 font-medium text-sm md:text-base" data-id="element-265">
              herramientas clínicas listas para usar
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-16" data-id="element-266">
          <p className="text-base md:text-xl text-white/70 leading-relaxed max-w-3xl mx-auto mb-6 md:mb-8 text-balance" data-id="element-267">
            Evaluación · Guiones · Protocolos · Vínculo · DPP · Gestión ·
            Comunicación · Autocuidado
          </p>
          <div className="inline-block bg-sage/20 text-sage-100 px-5 py-2.5 md:px-6 md:py-3 rounded-full font-bold border border-sage/30 text-sm md:text-base" data-id="element-268">
            Funciona desde hoy mismo en tu consulta
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-269">
          <p className="text-white/60 mb-4 md:mb-6 text-xs md:text-sm uppercase tracking-widest" data-id="element-270">
            Etapas y enfoques incluidos:
          </p>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-271">
            {etapas.map((etapa, i) => <div key={i} className="bg-white/10 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium flex items-center gap-1.5 md:gap-2 border border-white/5" data-id="element-272">
                <span data-id="element-273">{etapa.emoji}</span>
                <span data-id="element-274">{etapa.text}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}